export default __webpack_public_path__ + "static/media/order.f75ba500.svg";